/* unplugin-vue-components disabled */import script from "./MyMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMenu.vue?vue&type=script&setup=true&lang=js"

import "./MyMenu.vue?vue&type=style&index=0&id=395fd980&lang=css"

const __exports__ = script;

export default __exports__